/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Create_Guide_TitleInputs */

const en_knp_manager_create_guide_title = /** @type {(inputs: Knp_Manager_Create_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new KNP guide`)
};

const fr_knp_manager_create_guide_title = /** @type {(inputs: Knp_Manager_Create_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un nouveau guide KNP`)
};

const de_knp_manager_create_guide_title = /** @type {(inputs: Knp_Manager_Create_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen KNP-Leitfaden erstellen`)
};

const it_knp_manager_create_guide_title = /** @type {(inputs: Knp_Manager_Create_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una nuova guida KNP`)
};

const ru_knp_manager_create_guide_title = /** @type {(inputs: Knp_Manager_Create_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать новый путеводитель по КНП`)
};

const es_knp_manager_create_guide_title = /** @type {(inputs: Knp_Manager_Create_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear nueva guía KNP`)
};

const zh_cn2_knp_manager_create_guide_title = /** @type {(inputs: Knp_Manager_Create_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建新的克鲁格国家公园指南`)
};

const ja_knp_manager_create_guide_title = /** @type {(inputs: Knp_Manager_Create_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいKNPガイドを作成する`)
};

const hi_knp_manager_create_guide_title = /** @type {(inputs: Knp_Manager_Create_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई केएनपी गाइड बनाएं`)
};

const pt_pt2_knp_manager_create_guide_title = /** @type {(inputs: Knp_Manager_Create_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar novo guia do KNP`)
};

/**
* | output |
* | --- |
* | "Create new KNP guide" |
*
* @param {Knp_Manager_Create_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_create_guide_title = /** @type {((inputs?: Knp_Manager_Create_Guide_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Create_Guide_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_create_guide_title(inputs)
	if (locale === "de") return de_knp_manager_create_guide_title(inputs)
	if (locale === "it") return it_knp_manager_create_guide_title(inputs)
	if (locale === "ru") return ru_knp_manager_create_guide_title(inputs)
	if (locale === "es") return es_knp_manager_create_guide_title(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_create_guide_title(inputs)
	if (locale === "ja") return ja_knp_manager_create_guide_title(inputs)
	if (locale === "hi") return hi_knp_manager_create_guide_title(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_create_guide_title(inputs)
	return en_knp_manager_create_guide_title(inputs)
});